//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { detailData } from "@/api/pm/project";
import { getProjBudgetPersonData } from "@/api/pm/budget";

export default {
  name: "taskDetail",
  data() {
    return {
      gobackName: this.$route.params.gobackName,
      status: this.$route.params.status,
      projStatus: this.$route.params.projStatus,
      projTypeCode: this.$route.params.projTypeCode,
      respDeptCode: this.$route.params.respDeptCode,
      mainId: this.$route.params.mainId,
      // 主表数据
      from: {},
      // 合同数据
      contData: [],
      tabNum: 0,
      // 人员
      persons: [],
      personsShow: [],
      personName: ""
    };
  },
  async created() {
    // 加载数据
    await this.loadData();
    await this.loadPersons();
  },
  computed: {},
  mounted: function() {},
  methods: {
    // 查找
    searchEvent(event) {
      if (event.keyCode == 13) {
        this.getPersonList();
      }
    },
    // 清空条件
    clearFilter() {
      this.personName = "";
      this.getPersonList();
    },
    getPersonList() {
      let value = this.personName;
      this.personsShow = [];
      if (value) {
        this.persons.forEach(item => {
          if (item.personName.indexOf(value) > -1) {
            this.personsShow.push(item);
          }
        });
      } else {
        this.personsShow = this.persons;
      }
    },
    //时间格式化
    dateFormat(date) {
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    // 返回
    goback() {
      //this.$router.push({ name:'立项列表'});
      //this.$router.go(-1);
      this.$router.push({
        name: "立项列表",
        params: {
          projTypeCode: this.projTypeCode,
          status: this.status,
          projStatus: this.projStatus,
          respDeptCode: this.respDeptCode,
          gobackName: this.gobackName
        }
      });
    },
    // 加载数据
    async loadData() {
      var condition = { projId: this.mainId };
      await detailData(condition).then(response => {
        // 数据赋值
        this.from = response.projBasicInfo;
        this.contData = response.contData;
      });
    },
    // 加载人员信息
    async loadPersons() {
      debugger;
      await getProjBudgetPersonData({
        budgetId: "",
        projCode: this.from.projCode
      }).then(response => {
        this.persons = response.inPersonPlanData;
        this.personsShow = this.persons;
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/view/pm/project/projectDetail.vue